export default __webpack_public_path__ + "static/media/itemPickup.c499b904.mp3";